import React from 'react';

import { Group, Skeleton, Title } from '@mantine/core';
import { ReactComponent as KiloLogo } from 'assets/svg/long_kilo_blue_white.svg';

interface ISimpleHeaderWithCount {
  title: string;
  count?: number;
  isLoading?: boolean;
  isError?: boolean;
}

const SimpleHeaderWithCount = ({
  title,
  count,
  isLoading,
  isError,
}: ISimpleHeaderWithCount): JSX.Element => {
  const getCountDisplay = (): JSX.Element => {
    if (isLoading) {
      return <Skeleton height='2rem' width='5rem' />;
    }
    if (isError) {
      return (
        <Title order={3} color='red'>
          Error
        </Title>
      );
    }
    if (count || count === 0) {
      return (
        <Title order={3} color='gray'>
          {count}
        </Title>
      );
    }
    return <></>;
  };

  return (
    <div className='header'>
      <Group spacing='md' noWrap>
        <Title order={3} color='gray.8' align='center'>
          {title}
        </Title>
        {getCountDisplay()}
      </Group>
      <KiloLogo height='100%' width={50} />
    </div>
  );
};

export default SimpleHeaderWithCount;
